/** Stable daypart colors for timeline + list accents (theme-friendly). */
const PALETTE = [
  { id: 'sky', bar: '#3b82c4', soft: 'color-mix(in srgb, #3b82c4 22%, transparent)' },
  { id: 'clay', bar: '#c45a2c', soft: 'color-mix(in srgb, #c45a2c 22%, transparent)' },
  { id: 'amber', bar: '#c9a227', soft: 'color-mix(in srgb, #c9a227 22%, transparent)' },
  { id: 'forest', bar: '#3f8f6b', soft: 'color-mix(in srgb, #3f8f6b 22%, transparent)' },
  { id: 'slate', bar: '#6b7280', soft: 'color-mix(in srgb, #6b7280 22%, transparent)' },
  { id: 'violet', bar: '#7c6bc4', soft: 'color-mix(in srgb, #7c6bc4 22%, transparent)' },
] as const;

export type DaypartColor = (typeof PALETTE)[number];

export function daypartColorFor(key: string): DaypartColor {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length]!;
}
